export default {
  '未提交': '未提交',
  '待提交': '待提交',
  '待审核': '待审核',
  '审核通过': '审核通过',
  '未通过': '未通过',
  '已取消': '已取消',
  '已失效': '已失效',
  '已提交': '已提交',
  '未支付': '未支付',
  '已支付': '已支付',
  '已拒绝': '已拒绝',
  '已初审': '已初审',
  '已复审': '已复审',
  '男': '男',
  '女': '女',
}



// WEBPACK FOOTER //
// ./src/i18n/zh-cn/base/status.js